import { render, staticRenderFns } from "./mobileVideo.vue?vue&type=template&id=84229cc2&scoped=true&"
import script from "./mobileVideo.vue?vue&type=script&lang=js&"
export * from "./mobileVideo.vue?vue&type=script&lang=js&"
import style0 from "./mobileVideo.vue?vue&type=style&index=0&id=84229cc2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84229cc2",
  null
  
)

export default component.exports